import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { IonAlert, IonBadge, IonButton, IonCard, IonCardContent, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonPage, IonRow } from '@ionic/react';
import { logoYoutube, play, thumbsDown, thumbsUp } from 'ionicons/icons';

import ReactPlayer from 'react-player';

import Toolbar from '../components/Toolbar';

import { Feedback } from '../models/Feedback';
import { REACTION_SINAL, Word } from '../models/Word';

import { DETAILS_SIGNAL_ROUTER } from '../Routers';

import authService from '../services/AuthService';
import wordService from '../services/WordService';
import userService from '../services/UserService';

import { formatDate } from 'utils/Formats';

import { shareSection } from '../data/share-section.json'

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon
} from 'react-share'
import { User } from 'models/User';

const WordDetails: React.FC = () => {
  const location = useLocation()
  const history = useHistory()

  const [alertSendFeedback, setAlertSendFeedback] = useState(false);
  const [showError, setShowError] = useState(false);

  const [errorMsg, setErrorMsg] = useState('');

  const [word, setWord] = useState<Word>(new Word());
  const [user, setUser] = useState<User>(new User());

  const [feedbackList, setFeedbackList] = useState<Feedback[]>([]);
  const [hasFeedback, setHasFeedback] = useState<boolean>(true);

  const [feedbackType, setFeedbackType] = useState<REACTION_SINAL>(REACTION_SINAL.POSITIVO)

  // Url to player (Support to file and youtube)
  const [urlVideo, setUrlVideo] = useState<string>()

  const onSelectSignal = (sinalId: string) => {
    history.push(`${DETAILS_SIGNAL_ROUTER}?sinalId=${sinalId}`)
  }

  const checkIfUserHasFeedback = (_feedbacks: Feedback[]) => {
    const user = authService.user();

    const _hasFeedback = _feedbacks.some(feedback => {
      return feedback.userId === user?.uid
    });

    setHasFeedback(_hasFeedback);
  }


  const openVideoPath = (videoPath: string) => {
    wordService.getFileStorage(videoPath).getDownloadURL()
      .then(url => {
        setUrlVideo(url)
      })
      .catch(err => console.log(err))
  }

  const sendFeedback = (text: string) => {
    const user = authService.user()!;

    const feedback = new Feedback(user.displayName ?? 'Anonymous', user.uid, text, feedbackType, word.key)

    wordService.saveFeedback(feedback)
      .then(res => {
        setHasFeedback(true);
        setFeedbackList([...feedbackList, feedback])
      })
      .catch(err => console.log(err))
  }

  const onGiveFeedback = (reaction: REACTION_SINAL) => {
    const user = authService.user();

    if (user == null) {
      setErrorMsg('Apenas usuários logados podem mandar feeedback!')
      setShowError(true)
    } else {
      setAlertSendFeedback(true);
      setFeedbackType(reaction)
    }
  }

  const fetchDataWord = useCallback(async (wordId: string) => {
    const word = await wordService.getWordById(wordId);

    setWord(word);

    if (word.urlYoutube) {
      setUrlVideo(word.urlYoutube)
    } else if (word.videoFile) {
      openVideoPath(word.videoFile)
    }

    const user = await userService.getUser(word.owner);

    setUser(user);
  }, [])

  const fetchFeedbacks = useCallback((wordId) => {
    wordService.getFeedBacks(wordId)
      .then(_feedbacks => {
        setFeedbackList(_feedbacks);
        checkIfUserHasFeedback(_feedbacks)
      })
      .catch(err => console.error(err))

  }, []);

  useEffect(() => {
    const wordId = new URLSearchParams(location.search).get('wordId')

    if (wordId) {
      fetchDataWord(wordId);
      fetchFeedbacks(wordId);
    }
  }, [fetchDataWord, fetchFeedbacks, location.search])

  return (
    <IonPage>
      <Toolbar title={word.text} menuBtn={true} infoBtn={false} />

      <IonContent className="padding">
        <IonAlert
          isOpen={alertSendFeedback}
          onDidDismiss={() => setAlertSendFeedback(false)}
          header="Adicionar comentário"
          message="Seu comentário estará visível ao público"
          inputs={[
            { name: 'comentario', type: 'text', placeholder: 'Comentário' }
          ]}
          buttons={[
            { text: 'Enviar', handler: (data) => sendFeedback(data.comentario) },
            { text: 'Cancelar', handler: () => { setAlertSendFeedback(false) } },
          ]}
        />
        <IonAlert
          isOpen={showError}
          onDidDismiss={() => setShowError(false)}
          header={'Ops...'}
          message={errorMsg}
          buttons={['Ok']}
        />
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Sinônimo:</IonLabel>
            <IonLabel>{word?.synonymous}</IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Classe Gramatical:</IonLabel>
            <IonLabel>{word?.grammar}</IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Estado de Origem:</IonLabel>
            <IonLabel>{word?.state}</IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Categoria:</IonLabel>
            <IonLabel>{word?.category ?? 'Não definida'}</IonLabel>
          </IonItem>

          <IonItem hidden={!word.signalRight}>
            <h6>Configuração de Mão Direita</h6>
            <div className="alinhar">
              <img className="cursor" alt="Mão Direita" src={`assets/imgs/${word.signalRight}.png`} key={word.signalRight} height='100' width='100' onClick={() => onSelectSignal(word.signalRight)} />
            </div>
          </IonItem>

          <IonItem hidden={!word.signalLeft}>
            <h6>Configuração de Mão Esquerda</h6>
            <div className="alinhar">
              <img className="cursor" alt="Mão Esquerda" src={`assets/imgs/${word.signalLeft}.png`} key={word.signalLeft} height='100' width='100' onClick={() => onSelectSignal(word.signalLeft)} />
            </div>
          </IonItem>

          <IonItem>
            <div className="centralizar">
              <h3>Visualizar Sinal</h3>
            </div>
          </IonItem>

          <IonItem>
            <IonGrid>
              <IonRow className="ion-align-items-center ion-wrap">
                <IonCol>
                  <IonButton fill="outline" size="large" expand="block" onClick={() => setUrlVideo(word.urlYoutube)} disabled={!word.urlYoutube}>
                    <IonIcon className="ion-padding" icon={logoYoutube}></IonIcon>
                    <div className="indent">YouTube</div>
                  </IonButton>
                </IonCol>
                <IonCol>
                  <IonButton fill="outline" size="large" expand="block" onClick={() => openVideoPath(word.videoFile)} disabled={!word.videoFile}>
                    <IonIcon className="ion-padding" icon={play}></IonIcon>
                    <div className="indent">Stream</div>
                  </IonButton>
                </IonCol>
              </IonRow>
              <IonRow className="ion-padding ion-align-items-center" hidden={!urlVideo}>
                <ReactPlayer
                  style={{ margin: 'auto' }}
                  playing
                  muted
                  controls
                  loop
                  width='100%'
                  url={urlVideo}
                  config={{
                    youtube: {
                      playerVars: { showinfo: 0 }
                    }
                  }} />
              </IonRow>
            </IonGrid>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Autor:</IonLabel>
            <IonLabel>{user?.name}</IonLabel>
          </IonItem>

          <IonItem>
            <IonLabel position="stacked">Criado em:</IonLabel>
            <IonLabel>{formatDate(word?.createdIn?.toMillis())}</IonLabel>
          </IonItem>

          <IonItem>
            <IonGrid>
              {
                word?.tags.map((tag, i) =>
                  <IonBadge key={i} style={{ margin: '0 2px' }}>
                    #{tag}
                  </IonBadge>
                )
              }
            </IonGrid>
          </IonItem>

          <IonItem>
            <IonGrid>
              <IonRow className="ion-justify-content-end">
                <FacebookShareButton url={window.location.href}>
                  <FacebookIcon {...shareSection} />
                </FacebookShareButton>

                <TwitterShareButton url={window.location.href}>
                  <TwitterIcon {...shareSection} />
                </TwitterShareButton>

                <WhatsappShareButton url={window.location.href}>
                  <WhatsappIcon {...shareSection} />
                </WhatsappShareButton>

                <LinkedinShareButton url={window.location.href}>
                  <LinkedinIcon {...shareSection} />
                </LinkedinShareButton>

                <TelegramShareButton url={window.location.href}>
                  <TelegramIcon {...shareSection} />
                </TelegramShareButton>
              </IonRow>
            </IonGrid>
          </IonItem>

          <IonItem hidden={hasFeedback}>
            <IonGrid>
              <IonRow className="ion-align-between">
                <IonCol>
                  <h3>Avalie esse sinal</h3>
                </IonCol>
                <IonRow>
                  <IonCol>
                    <IonButton expand="block" color="secondary" size="large" disabled={hasFeedback} onClick={() => onGiveFeedback(REACTION_SINAL.POSITIVO)}>
                      <IonIcon icon={thumbsUp}> {word.votes.up}</IonIcon>
                    </IonButton>
                  </IonCol>
                  <IonCol>
                    <IonButton expand="block" color="danger" size="large" disabled={hasFeedback} onClick={() => onGiveFeedback(REACTION_SINAL.NEGATIVO)}>
                      <IonIcon icon={thumbsDown}> {word.votes.down} </IonIcon>
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonRow>
            </IonGrid>
          </IonItem>
        </IonList>

        <IonCard hidden={!feedbackList.length}>
          <IonCardContent>
            <IonCardTitle>Comentários ({feedbackList.length})</IonCardTitle>

            <IonList>
              {feedbackList.map((feedback, _index) =>
                <IonItem key={_index}>
                  <IonCardContent>{feedback.userName}</IonCardContent>
                  <IonCardContent>
                    {feedback.text}
                  </IonCardContent>
                </IonItem>
              )}
            </IonList>
          </IonCardContent>
        </IonCard>
      </IonContent>
    </IonPage>
  )
}

export default WordDetails

